import { MenuItem, Typography, Box, Divider } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { useEffect } from "react"; // Import useEffect

const countries = [
  {
    code: "fr",
    name: "Français",
    country_code: "fr",
  },
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
  {
    code: "ar",
    name: "Arabic",
    country_code: "ar",
  },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); 
    localStorage.setItem("userLanguage", lng); 
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("userLanguage");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage); 
    }
  }, [i18n]);

  return (
    <>
      <Box sx={{ px: 1 }}>
        <Divider sx={{ mx: 1 }} />
        {countries.map((lng) => (
          <MenuItem
            key={lng.code}
            onClick={() => changeLanguage(lng.code)} 
            disabled={i18n.language === lng.code}
            sx={{
              gap: 2,
              fontFamily: "Poppins",
              '&.Mui-disabled': {
                opacity: 0.5
              }
            }}
          >
            <span className={`fi fi-${lng.country_code}`} />
            <Typography sx={{ fontFamily: "Poppins" }}>
              {lng.name}
            </Typography>
          </MenuItem>
        ))}
      </Box>
    </>
  );
};

export default LanguageSelector;